/*
 * ============================================================
 * MODI — Reviews wall pause control
 * WCAG 2.2.2 asks for a mechanism to stop moving content that
 * runs longer than five seconds; hover is not one a keyboard or
 * touch user has. The button only toggles `.is-paused` on the
 * wall named by its aria-controls, so the CSS marquee stays the
 * single owner of animation state.
 * Delegated from the document → Shopify theme-editor safe: a
 * section the editor re-renders needs no re-init.
 * ============================================================
 */
(function () {
  'use strict';
  if (window.modiReviewsPause) return;
  window.modiReviewsPause = true;

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-modi-reviews-pause]');
    if (!btn) return;
    var wall = document.getElementById(btn.getAttribute('aria-controls'));
    if (!wall) return;
    var paused = wall.classList.toggle('is-paused');
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.textContent = paused ? btn.dataset.playLabel : btn.dataset.pauseLabel;
  });
})();
